module.exports = __webpack_public_path__ + "img/F975.608d390e.jpg";